module.exports = __webpack_public_path__ + "static/media/strapi.c2c413f2.svg";